import type { SgwtChatbotMessage } from '../../shared/chatbot.types';
import type { DxAgentFactoryPromptResponse } from './dx-agent-factory.types';

function convertPromptResponse(response: DxAgentFactoryPromptResponse): SgwtChatbotMessage {
  let calls = 'No API calls';
  if (response.toolCalls.length > 0) {
    calls = `${response.toolCalls.length} API called:\n`;
    calls += response.toolCalls
      .map((call) => ` - **${call.name}**: \`${call.result?.requestMethod?.toUpperCase()}\` ${call.result?.requestUri}`)
      .join('\n');
  }

  return {
    conversationId: response.conversationId,
    role: 'bot',
    id: '',
    message: {
      content: response.response,
      format: 'markdown',
    },
    sources: {
      content: calls,
      format: 'markdown',
    },
  };
}

export const DxConverter = {
  convertPromptResponse,
};
